module.exports = __webpack_public_path__ + "img/logo-default_old.b841148c.png";